import { HttpService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { isDefined, isUndefined } from '@philips-internal/oswald-ui-utils';
class DefaultFilterHandler {
    getConfiguration() {
        if (isUndefined(this.fileHandlerConfiguration)) {
            throw new Error('[Default Filter Handler]: Handler is not configured.');
        }
        return this.fileHandlerConfiguration;
    }
    isConfigured() {
        return isDefined(this.fileHandlerConfiguration);
    }
    load(filterId) {
        const { loadUrl } = this.getConfiguration();
        return HttpService.get(loadUrl, { filterId })
            .then(response => response.body || [])
            .catch(() => []);
    }
    remove(filterId, recordId) {
        const { removeUrl } = this.getConfiguration();
        return HttpService.delete(removeUrl, { filterId, recordId });
    }
    save(filterId, filter) {
        const { saveUrl } = this.getConfiguration();
        return HttpService.post(saveUrl, { filterId }, { body: { ...filter } });
    }
    setConfiguration(fileHandlerConfiguration) {
        this.fileHandlerConfiguration = fileHandlerConfiguration;
    }
}
export { DefaultFilterHandler, };
//# sourceMappingURL=default-filter-handler.js.map